module.exports = __webpack_public_path__ + "img/CI.488da1fa.svg";